import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Badge, { BadgeBg } from 'components/base/Badge';
import { OrderingOpinionVerdict } from 'utils/types';

type OrderingOpinionBadgeProps = {
  verdict?: OrderingOpinionVerdict | number | null;
  opinion?: string | null;
  tooltipId?: string;
};

const VERDICT_COPY: Record<
  'OK' | 'Lower' | 'Increase',
  { label: string; bg: BadgeBg }
> = {
  OK: { label: 'OK', bg: 'success' },
  Lower: { label: 'Lower', bg: 'warning' },
  Increase: { label: 'Increase', bg: 'info' }
};

const normalizeVerdict = (
  verdict: OrderingOpinionVerdict | number | null | undefined,
  opinion: string | null | undefined
): 'OK' | 'Lower' | 'Increase' | null => {
  if (verdict === 'OK' || verdict === 10) {
    return 'OK';
  }
  if (verdict === 'Lower' || verdict === 20) {
    return 'Lower';
  }
  if (verdict === 'Increase' || verdict === 30) {
    return 'Increase';
  }

  if (!opinion) {
    return null;
  }

  const text = opinion.toLowerCase();
  if (
    text.includes('increase') ||
    text.includes('order more') ||
    text.includes('ordering more')
  ) {
    return 'Increase';
  }
  if (
    text.includes('reduc') ||
    text.includes('lower the') ||
    text.includes('too high')
  ) {
    return 'Lower';
  }

  return 'OK';
};

const OrderingOpinionBadge = ({
  verdict,
  opinion,
  tooltipId
}: OrderingOpinionBadgeProps) => {
  const resolved = normalizeVerdict(verdict, opinion);
  if (!resolved || !opinion) {
    return null;
  }

  const copy = VERDICT_COPY[resolved];

  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip
          id={tooltipId ?? `ordering-opinion-${resolved}`}
          className="text-start"
          style={{ maxWidth: 360 }}
        >
          {opinion}
        </Tooltip>
      }
    >
      <span className="d-inline-flex">
        <Badge bg={copy.bg} className="fs-10" style={{ cursor: 'help' }}>
          {copy.label}
        </Badge>
      </span>
    </OverlayTrigger>
  );
};

export default OrderingOpinionBadge;
